import { useCallback } from 'react'
import { Klass, LexicalNode, LexicalNodeReplacement } from 'lexical'

import { TEXT_TYPE, writeCopyContentToClipboard } from '../../../apps/professional-app/fa/MeetingSummary/copy'
import { LEXICAL_NODES } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'

import { addToast } from '../../../store/toast/toastSlice'
import { useAppDispatch } from '../../../store/hooks'

import { AIAgentResultState, getEditorContent } from '../EditableAIAgentResult/EditableAIAgentResult'

interface UseAIAgentResultCopyProps {
  aiAgentResultState: AIAgentResultState | null
  lexicalNodes?: ReadonlyArray<Klass<LexicalNode> | LexicalNodeReplacement>
}

export const useAIAgentResultCopy = ({ aiAgentResultState, lexicalNodes = LEXICAL_NODES }: UseAIAgentResultCopyProps) => {
  const dispatch = useAppDispatch()

  const handleCopy = useCallback(async () => {
    if (!aiAgentResultState) {
      return
    }
    const editorContent = getEditorContent(aiAgentResultState.editorState, lexicalNodes)
    if (!editorContent) {
      return
    }
    await writeCopyContentToClipboard(editorContent)
    dispatch(addToast({ variant: 'info', title: 'Copied', messages: ['Copied to Clipboard!'] }))
  }, [aiAgentResultState, lexicalNodes, dispatch])

  const handleMailToClicked = useCallback(() => {
    if (!aiAgentResultState) {
      return
    }
    const editorContent = getEditorContent(aiAgentResultState.editorState, lexicalNodes)
    if (!editorContent) {
      return
    }
    window.location.href = `mailto:?body=${encodeURIComponent(editorContent[TEXT_TYPE])}`
  }, [aiAgentResultState, lexicalNodes])

  return {
    handleCopy,
    handleMailToClicked,
  }
}
